module.exports = __webpack_public_path__ + "static/img/sv-1.3a17ba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/sv-1.jpg
// module id = bAE3
// module chunks = 0